"use client";

import { useEffect, useState } from "react";

export function useHideOnScroll(offset = 150) {
  const [hidden, setHidden] = useState(false);
  const [lastScroll, setLastScroll] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(window.innerWidth < 768);

    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const onScroll = () => {
      if (!isMobile) return;

      const current = window.scrollY;

      if (current < offset) {
        setHidden(false);
        setLastScroll(current);
        return;
      }

      if (current > lastScroll) {
        setHidden(true);
      } else {
        setHidden(false);
      }

      setLastScroll(current);
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [lastScroll, offset, isMobile]);

  return hidden;
}